// UserLeaderboardGridCategory.jsx
import React from 'react';

import UniversalComponent from '../component/UniversalComponent.jsx';
import { createInitialStoreWithRequest } from '../createInitialStore.js';
import getMetaTagsForHelmet from '../resource/getMetaTagsForHelmet.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { BRANDING_NAME } from '../RemoteConfigKeys.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { getFeedCategory } from '../resource/feedUtils.js';
import getTranslationKey from '../resource/getTranslationKey.js';
import getHttpProxyHeaders from '../resource/getHttpProxyHeaders.js';
import { fetchFeedTotalCount } from '../resource/fetchFeedTotalCount.js';

/**
 * React Router loader for UserLeaderboardGridCategory
 * Uses lightweight HEAD request to check feed count for noindex determination
 */
export const loader = async ({ params, request, i18nInstance }) => {
  const { store } = await createInitialStoreWithRequest({ params, request });
  const state = store.getState();

  const brandingName = getRemoteConfigData(state, BRANDING_NAME) || 'SWAG';

  // Use i18n instance from loader
  const t = i18nInstance.getFixedT(null, TranslationNamespace.SEO);

  // Parse URL to get search params
  const url = new URL(request.url);
  const category = getFeedCategory({
    category: params.category,
    search: url.search,
  });

  // Get HTTP proxy headers for API calls
  const httpProxyHeaders = getHttpProxyHeaders({ request });

  // Use lightweight HEAD request to check if feed has content
  // This is more efficient than fetching full feed data
  const feedCount = await fetchFeedTotalCount({
    feedNameWithQuery: category,
    httpProxyHeaders,
  });

  // Get title for meta tags
  const titleI18nId = getTranslationKey({ key: category });
  const feedTitle = t(titleI18nId, { ns: TranslationNamespace.FEED });
  const defaultTitle = t('seo-home-title');
  const title = `${feedTitle} - ${defaultTitle}`;

  // If no content found, add noindex (matching Next.js: if (userIds.length === 0) return getNoIndexMetadata())
  const robots = feedCount === 0 ? ['noindex', 'nofollow'] : [];

  const meta = getMetaTagsForHelmet({
    title,
    siteName: brandingName,
    hostname: request?.headers?.get('host') || 'swag.live',
    robots,
  });

  return {
    meta,
    staticContext: {
      requestHeaders: {
        hostname: request?.headers?.get('host') || 'swag.live',
      },
    },
  };
};

const UserLeaderboardGridCategoryRoute = () => {
  return (
    <UniversalComponent
      filename="Container_UserFeedGridList"
      isLeaderboard
      importer={
        /* #__LOADABLE__ */ () => import('../container/UserFeedGridList.js')
      }
    />
  );
};

export default UserLeaderboardGridCategoryRoute;
